<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-21 16:10:44
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-17 17:23:17
 * @name: 通用审批
 * @Description: 通用审批
 * @FilePath: \project\src\components\afterSale\dialog-approve-normal.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="审批处理" width="650px" :visible.sync="show" @close="close">
    <div class="content">
      <div class="row">
        <font class="label">审批结果</font>
        <font class="text">{{
          type === "resolve" ? "审批通过" : "审批拒绝"
        }}</font>
      </div>
      <div class="row">
        <font class="label">{{
          type === "resolve" ? "审批建议" : "拒绝原因"
        }}</font>
        <el-input
          class="remark"
          type="textarea"
          :rows="2"
          :placeholder="
            '请输入' + (type === 'resolve' ? '审批建议' : '拒绝原因') + '...'
          "
          v-model="remark"
        >
        </el-input>
      </div>
      <div class="row" v-if="type === 'reject' && process_list.length > 0">
        <font class="label">选择退回的步骤</font>
        <el-select
          class="select"
          size="mini"
          v-model="back_process_id"
          placeholder="请选择退回的步骤"
        >
          <el-option
            :label="item.process_name"
            :value="item.id"
            v-for="item of process_list"
            :key="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="btn-group">
        <el-button size="mini" @click="show = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import workflowService from "@/module/workflow/workflow.service";
import { debounceation } from '@/utils/decorator';
export default {
  data() {
    return {
      issueService: new issueService(),
      workflowService: new workflowService(),
      show: false,
      issue_id: "", //工单id
      run_process_id: "", //工作流id
      type: "", //审批结果 resolve 通过 reject 拒绝
      value: "", //act字段
      remark: "", //备注
      process_list: [], //可打回步骤列表
      back_process_id: '', //打回的步骤id
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} item 传递数据
     */
    open(param) {
      this.issue_id = param.issue_id;
      this.run_process_id = param.run_process_id;
      this.type = param.type;
      this.value = param.value;
      if (this.type === "resolve") {
        this.show = true;
      } else {
        this.workflowService
          .getSaleSercviceFlowProcessList({
            run_process_id: this.run_process_id,
          })
          .then((res) => {
            this.process_list = res.data;
            this.show = true;
          });
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.type = "";
      this.value = "";
      this.remark = "";
      this.process_list = [];
      this.back_process_id = '';
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交
     */
    @debounceation(300)
    confirm() {
      let req = {
        issue_id: this.issue_id,
        run_process_id: this.run_process_id,
        act: this.value,
        check_con: this.remark,
      };
      if(this.type === 'reject') {
        req.back_process_id = this.back_process_id ?? 0;
      }
      this.issueService
        .doApprove(req)
        .then((res) => {
          this.$emit("finish");
          this.show = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  @extend .et-flex-column-normal;
  .row {
    width: 100%;
    margin-bottom: 18px;
    @extend .et-flex-normal;
    font-size: $Vars-font-content-size;
    .label {
      color: $Vars-font-important-color;
      font-weight: bold;
      margin-right: 10px;
      width: calc(7 * #{$Vars-font-content-size});
      line-height: 28px;
    }
    .text {
      color: $Vars-font-normal-color;
      line-height: 28px;
    }
    .remark {
      flex: 1;
    }
    .select {
      flex: 1;
    }
  }
  .btn-group {
    width: 100%;
    @extend .et-flex-center;
  }
}
</style>